<h1 mat-dialog-title class="dialog-title">{{ data.title }}</h1>
<div mat-dialog-content>
  @if (data.isImage) {
    <div class="image-container">
      <img [src]="data.imageUrl" [alt]="data.title" class="content-image">
    </div>
  } @else {
    <div class="iframe-container">
      <iframe [src]="data.embedUrl" frameborder="0" scrolling="no"></iframe>
    </div>
  }
</div>
<div mat-dialog-actions class="dialog-actions">
  <button mat-button class="btn-home" (click)="closeDialog()">Close</button>
</div>


